import React from "react";
import ModalConfirm from "../../common/components/ModalConfirm";

type TProps = {
  onConfirm: () => void;
  open: boolean;
  styles: {
    [x: string]: any;
  };
  handleClose: () => void;
};

const ModalConfirmPremium: React.FC<TProps> = (props) => {
  const { onConfirm, handleClose, open, styles } = props;
  return (
    <ModalConfirm
      title="common.bottombar.notification"
      content="content.modal.confirm.premium"
      onConfirm={onConfirm}
      onCancel={handleClose}
      textConfirm="text.btn.modal.confirm.premium"
      handleClose={handleClose}
      open={open}
      styles={styles}
      classBtnConfirm="bg-primary text-white rounded-[30px] focus:outline-none text-white text-[13px] px-5 py-2.5 mr-2 mb-2"
    />
  );
};
export default ModalConfirmPremium;
